import axios from 'axios'
import * as d3 from 'd3'
import { tsvParseRows } from 'd3-dsv'

const GET_HOME_LISTINGS = 'GET_HOME_LISTINGS';

const API_ENDPOINTS = {
    'poblacion': 'api/poblacion',
    'indices_pob': 'api/polygons',
    'streets': 'api/lines',
    'income': 'api/incomes',
    'neighborhoods': 'api/neighborhood',
    'sections': 'api/section',
    'ivs': 'api/idx_vs',
    'pendiente': 'api/slope',
    'iso_deportes': 'api/sport',
    'iso_bus_peatonal': 'api/bus',
    'iso_coche_edu': 'api/educacion',
    'iso_coche_health': 'api/health',
    'iaeu': 'api/idx_aeu',
    'def_equ': 'api/deficit_equ',
    'def_veg': 'api/deficit_veg',
    'den_urb': 'api/densidad_urb',
    'uso_sue': 'api/usos_suelo',
    'ndvi': 'api/raster/ndvi',
    'ndbi': 'api/raster/ndbi',
    'facilities': 'api/facility',
    'pein': 'api/pein',
    'icuc': 'api/idx_cuc',
    'street_slope': 'api/street_slope',
    'iicu': 'api/idx_iicu',
    'zipcodes': 'api/ny_ct_renta'
}

const requestAirBnb = () => ({
   method: 'GET',
   url: './assets/airbnb.json'
});

const requestEstratosFile = () => ({
   method: 'GET',
   url: './assets/bogota/EstratosBogota2.topojson'
});

const requestLocationCategoriesFile = () => ({
   method: 'GET',
   url: './assets/locationCategories.json'
});

const requestLocations = () => ({
    method: 'GET',
    url: './assets/bogota/bogotaLocations.json'
})

const requestSubwayStations = () => ({
    method: 'GET',
    url: './assets/newyorkcity/subway-stations.json'
})

const requestBoroughBackground = () => ({
    method: 'GET',
    url: './assets/newyorkcity/nyc-map.json'
})

const requestTristateZipcodeFile = () => ({
    method: 'GET',
    url: './assets/clusters_merged_tristate.json'
})

const requestPCAComponentCoordinates = () => ({
    method: 'GET',
    url: './assets/knn_0_1.csv'
})

const requestUSPlaceNames = () => ({
    method: 'GET',
    url: './assets/us_locations.json'
})

const requestPhantomLines = () => ({
    method: 'GET',
    url: './assets/newyorkcity/phantom-lines.json'
})

const requestSubwayLines = () => ({
    method: 'GET',
    url: './assets/newyorkcity/subway-lines.geojson'
})

const requestBogotaSectors = () => ({
    method: 'GET',
    url: './assets/bogota/sectCatast.json'
})

const requestFromDatabase = _v => ({
    method: 'GET',
    url: `https://estado.us/${ API_ENDPOINTS[_v]}`
})

export const getEstratos = () => {
    const url = requestEstratosFile();
    return axios(url)
        .then(res => res.data )
        .then(estratos => ({ estratos: estratos }))
    ;
}

export const getListings = () => {
    const url = requestAirBnb();
    return axios(url)
        .then(res => res.data )
        .then(listings => listings )
    ;
}

export const getLocationCategories = () => {
    const url = requestLocationCategoriesFile();
    return axios(url)
        .then(res => res.data )
        .then(categories => categories )
    ;
}

export const getLocations = () => {
    const url = requestLocations();
    return axios(url)
        .then(res => res.data )
        .then(locations => locations )
    ;
}

export const getTristatePolygons = () => {
    const url = requestTristateZipcodeFile()
    return axios(url)
        .then(res => res.data)
        .then(polygons => polygons)
}

export const getBoroughBackgrounds = () => {
    const url = requestBoroughBackground()
    return axios(url)
        .then(res => res.data)
        .then(boroughs => boroughs)
}

export const getPCAComponents = obj => {
    const { w, h }= obj
    const x  = d3.scaleLinear().range([0,w]).domain([-.5,1])
    const y = d3.scaleLinear().range([h,0]).domain([-.25,1])
    const url = requestPCAComponentCoordinates()
    return axios(url)
        .then(res => res.data)
        .then(csv => tsvParseRows(csv, o => {
            return [x(o[1]),y(o[2]),parseFloat(o[0]), parseInt(o[3])]
        }))
}

export const getUSPlaceNames = () => {
    const url = requestUSPlaceNames()
    return axios(url)
        .then(res => res.data)
        .then(locations => locations)
}

export const getPhantomPaths = () => {
    const url = requestPhantomLines()
    return axios(url)
        .then(res => res.data)
        .then(lines => lines)
}

export const getSubwayPaths = () => {
    const url = requestSubwayLines()
    return axios(url)
        .then(res => res.data)
        .then(lines => lines)
}

export const getSubwayStations = () => {
    const url = requestSubwayStations()
    return axios(url)
        .then(res => res.data)
        .then(stations => stations)
}

export const getSectors = () => {
    const url = requestBogotaSectors()
    return axios(url)
        .then(res => res.data)
        .then(sectors => sectors)
}

export const getLayerFromDatabase = _v => {
    const url = requestFromDatabase(_v)
    console.log(url)
    return axios(url)
        .then(res => res.data)
        .then(layer => layer)
}
